<template>
    <div class="flex items-center space-x-3">
        <button
            @click="$emit('share')"
            class="p-2 rounded-full bg-gray-100 text-gray-400 hover:bg-gray-200 transition-colors"
        >
            <Share2 class="w-5 h-5" />
        </button>
    </div>
</template>

<script setup>
import {Share2 } from 'lucide-vue-next'
defineEmits(['share'])
</script>
